import { render, staticRenderFns } from "./pagination-base.vue?vue&type=template&id=2e6a29fc&scoped=true"
import script from "./pagination-base.vue?vue&type=script&lang=js"
export * from "./pagination-base.vue?vue&type=script&lang=js"
import style0 from "./pagination-base.vue?vue&type=style&index=0&id=2e6a29fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a29fc",
  null
  
)

export default component.exports